const WEBVIEW_SANDBOX_PERMISSIONS: readonly string[] = [
  'allow-same-origin',
  'allow-scripts',
  'allow-forms',
  'allow-top-navigation',
  'allow-popups',
  'allow-popups-to-escape-sandbox',
];

/**
 * Sandbox permission list shared by every embedded webview iframe.
 *
 * `allow-popups` lets embedded pages open links that target a new browsing
 * context (`target="_blank"`, `window.open`), and
 * `allow-popups-to-escape-sandbox` keeps the opened page out of the sandbox so
 * third party flows such as payment providers keep working.
 */
export const WEBVIEW_IFRAME_SANDBOX: string =
  WEBVIEW_SANDBOX_PERMISSIONS.join(' ');
